import { render, staticRenderFns } from "./ModalPackagingSettings.vue?vue&type=template&id=453623a2&scoped=true&"
import script from "./ModalPackagingSettings.vue?vue&type=script&lang=js&"
export * from "./ModalPackagingSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalPackagingSettings.vue?vue&type=style&index=0&id=453623a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453623a2",
  null
  
)

export default component.exports